import React, { Fragment, useEffect, useRef } from "react"
import PropTypes from "prop-types"
import classnames from "classnames"

import styles from "./styles.css"

const ModalAutoServices = ({
  children,
  isOpenModal,
  closeModal,
  positionModalClass
}) => {
  const refModal = useRef(null)

  const containerModal = classnames(styles.containerModal, positionModalClass)

  const handleCloseModal = (e) => {
    if (
      isOpenModal &&
      refModal.current &&
      !refModal.current.contains(e.target)
    ) {
      closeModal(e)
    }
  }

  useEffect(() => {
    document.addEventListener("click", handleCloseModal)

    return () => {
      document.removeEventListener("click", handleCloseModal)
    }
  }, [isOpenModal])

  return (
    <Fragment>
      {isOpenModal && (
        <nav className={containerModal} ref={refModal}>
          <ul className="u-block">{children}</ul>
        </nav>
      )}
    </Fragment>
  )
}

ModalAutoServices.propTypes = {
  children: PropTypes.node,
  isOpenModal: PropTypes.bool,
  closeModal: PropTypes.func,
  positionModalClass: PropTypes.string
}

export default ModalAutoServices



// WEBPACK FOOTER //
// ./src/components/ModalAutoServices/index.js